import React, { Component } from "react";
import { Typography, Paper, Button, withStyles } from "@material-ui/core";
import { Link } from "react-router-dom";
import Grid from "@material-ui/core/Grid";
import { compose } from "redux";
import { connect } from "react-redux";
import { AddressPicker } from "./AddressPicker";

const styles = theme => ({
  header: {
    marginBottom: 30
  },
  text: {
    marginBottom: 30
  },
  paper: {
    position: "absolute",
    top: 0,
    left: 20,
    maxWidth: "30%",
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
    padding: theme.spacing(2),
    [theme.breakpoints.up(600 + theme.spacing(3) * 2)]: {
      marginTop: theme.spacing(6),
      marginBottom: theme.spacing(6),
      padding: '44px 60px'
    }
  }
});

class SearchBox extends Component {
  state = { orderMade: false };

  order = (address1, address2) => {
    this.setState({
      orderMade: true
    });
    this.props.order(address1, address2);
  };

  reset = () => {
    this.setState({
      orderMade: false
    });
    this.props.reset();
  };

  render() {
    const { orderMade } = this.state;
    const { profileUpdated, classes } = this.props;
    if (!profileUpdated) {
      return (
        <Paper className={classes.paper}>
          <Grid container spacing={24}>
            <Grid item xs={12}>
              <Typography className={classes.header} component="h1" variant="h4" align="left">
                Заполните платежные данные
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography className={classes.text}>
                Укажите информацию о банковской карте, чтобы сделать заказ.
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Button
                variant="contained"
                color="primary"
                fullWidth
                component={Link}
                to="/profile"
              >
                Перейти в профиль
              </Button>
            </Grid>
          </Grid>
        </Paper>
      );
    }
    if (orderMade) {
      return (
        <Paper className={classes.paper}>
          <Grid container>
            <Grid item xs={12}>
              <Typography className={classes.header} component="h1" variant="h4" align="left">
                Заказ размещён
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography className={classes.text}>
                Ваше такси уже едет к вам. Прибудет приблизительно через 10
                минут.
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Button variant="contained" color="primary" fullWidth onClick={this.reset}>
                Сделать новый заказ
              </Button>
            </Grid>
          </Grid>
        </Paper>
      );
    }
    return <AddressPicker order={this.order} />;
  }
}

export default compose(
  withStyles(styles),
  connect(state => ({ profileUpdated: !!state.profile }))
)(SearchBox);
